import { LocalizedRichText, LocalizedText } from "@/i18n/LocalizedText";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { InAppBrowserSource } from "@/lib/googleAuth";

type InAppBrowserGoogleAuthDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  sourceApp: InAppBrowserSource;
};

const SOURCE_APP_NAME: Record<InAppBrowserSource, string> = {
  linkedin: "LinkedIn",
  telegram: "Telegram",
  instagram: "Instagram",
  facebook: "Facebook",
  tiktok: "TikTok",
  snapchat: "Snapchat",
  pinterest: "Pinterest",
  reddit: "Reddit",
  twitter: "X/Twitter",
  unknown: "this app",
};

const SOURCE_APP_GUIDANCE: Record<InAppBrowserSource, string> = {
  linkedin: "Use the menu (three dots) and choose Open in browser.",
  telegram:
    "Use the menu and open this page in Safari or Chrome to continue with Google sign-in.",
  instagram: "Use the menu and choose Open in browser.",
  facebook: "Use the menu and choose Open in browser.",
  tiktok: "Use the menu or Share actions, then choose Open in browser.",
  snapchat: "Use the menu to open this page in your default browser.",
  pinterest: "Use the menu and choose Open in browser.",
  reddit: "Use the menu and choose Open in browser.",
  twitter: "Use the share/menu actions and choose Open in browser.",
  unknown: "Use this app's menu and choose Open in browser.",
};

export default function InAppBrowserGoogleAuthDialog({
  open,
  onOpenChange,
  sourceApp,
}: InAppBrowserGoogleAuthDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            <LocalizedText id="legacy.open.nobori.in.safari.or.chrome.68gd7w" />
          </DialogTitle>
          <DialogDescription>
            <LocalizedRichText
              id="googleAuth.inAppBrowser.description"
              values={{ sourceApp: SOURCE_APP_NAME[sourceApp] }}
            />
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 text-sm text-muted-foreground">
          <p>{SOURCE_APP_GUIDANCE[sourceApp]}</p>
          <p>
            <LocalizedText id="legacy.you.can.continue.with.email.sign.in.or.10i0r36" />
          </p>
        </div>
        <DialogFooter className="sm:justify-start">
          <Button
            type="button"
            onClick={() => onOpenChange(false)}
            className="cursor-pointer bg-[#FF5E00] text-white hover:bg-[#ff8138]"
          >
            <LocalizedText id="legacy.continue.with.email.instead.19vvdd6" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
